import { useTranslation } from 'react-i18next'

import { Button } from 'src/components/Button/Button'

import type { Category } from 'src/types/Category'

interface BlogCategoryLinkProps {
  category: Category
  active?: boolean
}

export const BlogCategoryLink = ({ category, active }: BlogCategoryLinkProps) => {
  const {
    i18n: { language },
  } = useTranslation()

  const shouldRenderLink = category.lang === language && category.name !== 'Uncategorized' && category.count > 0

  if (!shouldRenderLink) {
    return null
  }

  const href = `/${language}/a/${category.slug ?? ''}`

  return (
    <Button
      href={active ? `/${language}/a/` : href}
      key={href}
      variant="secondary"
      data-testid="category-header-link"
      active={active}
    >
      {category.name.replace('#', '')}
    </Button>
  )
}
